import {
  saLimitedReleaseDetailConstants,
  createSaLimitedReleaseDetailConstants,
  editSaLimitedReleaseDetailConstants,
  activateSaLimitedReleaseDetailConstants,
  deactivateSaLimitedReleaseDetailConstants,
  deleteSaLimitedReleaseDetailConstants,
} from "../_redux-constants";

export function saLimitedReleasesDetailReducer(
  state = {
    saLimitedReleaseDetailLoading: false,
    saLimitedReleaseDetailData: null,
    saLimitedReleaseDetailError: null,

    createSaLimitedReleaseDetailLoading: false,
    createSaLimitedReleaseDetailData: null,
    createSaLimitedReleaseDetailError: null,

    editSaLimitedReleaseDetailLoading: false,
    editSaLimitedReleaseDetailData: null,
    editSaLimitedReleaseDetailError: null,

    activateSaLimitedReleaseDetailLoading: false,
    activateSaLimitedReleaseDetailData: null,
    activateSaLimitedReleaseDetailError: null,

    deactivateSaLimitedReleaseDetailLoading: false,
    deactivateSaLimitedReleaseDetailData: null,
    deactivateSaLimitedReleaseDetailError: null,

    deleteSaLimitedReleaseDetailLoading: false,
    deleteSaLimitedReleaseDetailData: null,
    deleteSaLimitedReleaseDetailError: null,
  },
  action
) {
  switch (action.type) {
    case saLimitedReleaseDetailConstants.SA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        saLimitedReleaseDetailLoading: true,
        saLimitedReleaseDetailData: null,
        saLimitedReleaseDetailError: null,
      });
    case saLimitedReleaseDetailConstants.SA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        saLimitedReleaseDetailLoading: false,
        saLimitedReleaseDetailData: action.data,
      });
    case saLimitedReleaseDetailConstants.SA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        saLimitedReleaseDetailLoading: false,
        saLimitedReleaseDetailData: null,
        saLimitedReleaseDetailError: action.error,
      });
    case createSaLimitedReleaseDetailConstants.CREATE_SA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        createSaLimitedReleaseDetailLoading: true,
        createSaLimitedReleaseDetailData: null,
        createSaLimitedReleaseDetailError: null,
      });
    case createSaLimitedReleaseDetailConstants.CREATE_SA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        createSaLimitedReleaseDetailLoading: false,
        createSaLimitedReleaseDetailData: action.data,
      });
    case createSaLimitedReleaseDetailConstants.CREATE_SA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        createSaLimitedReleaseDetailLoading: false,
        createSaLimitedReleaseDetailData: null,
        createSaLimitedReleaseDetailError: action.error,
      });
    case editSaLimitedReleaseDetailConstants.EDIT_SA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        editSaLimitedReleaseDetailLoading: true,
        editSaLimitedReleaseDetailData: null,
        editSaLimitedReleaseDetailError: null,
      });
    case editSaLimitedReleaseDetailConstants.EDIT_SA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        editSaLimitedReleaseDetailLoading: false,
        editSaLimitedReleaseDetailData: action.data,
      });
    case editSaLimitedReleaseDetailConstants.EDIT_SA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        editSaLimitedReleaseDetailLoading: false,
        editSaLimitedReleaseDetailData: null,
        editSaLimitedReleaseDetailError: action.error,
      });
    case activateSaLimitedReleaseDetailConstants.ACTIVATE_SA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        activateSaLimitedReleaseDetailLoading: true,
        activateSaLimitedReleaseDetailData: null,
        activateSaLimitedReleaseDetailError: null,
      });
    case activateSaLimitedReleaseDetailConstants.ACTIVATE_SA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        activateSaLimitedReleaseDetailLoading: false,
        activateSaLimitedReleaseDetailData: action.data,
      });
    case activateSaLimitedReleaseDetailConstants.ACTIVATE_SA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        activateSaLimitedReleaseDetailLoading: false,
        activateSaLimitedReleaseDetailData: null,
        activateSaLimitedReleaseDetailError: action.error,
      });
    case deactivateSaLimitedReleaseDetailConstants.DEACTIVATE_SA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        deactivateSaLimitedReleaseDetailLoading: true,
        deactivateSaLimitedReleaseDetailData: null,
        deactivateSaLimitedReleaseDetailError: null,
      });
    case deactivateSaLimitedReleaseDetailConstants.DEACTIVATE_SA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        deactivateSaLimitedReleaseDetailLoading: false,
        deactivateSaLimitedReleaseDetailData: action.data,
      });
    case deactivateSaLimitedReleaseDetailConstants.DEACTIVATE_SA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        deactivateSaLimitedReleaseDetailLoading: false,
        deactivateSaLimitedReleaseDetailData: null,
        deactivateSaLimitedReleaseDetailError: action.error,
      });
    case deleteSaLimitedReleaseDetailConstants.DELETE_SA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        deleteSaLimitedReleaseDetailLoading: true,
        deleteSaLimitedReleaseDetailData: null,
        deleteSaLimitedReleaseDetailError: null,
      });
    case deleteSaLimitedReleaseDetailConstants.DELETE_SA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        deleteSaLimitedReleaseDetailLoading: false,
        deleteSaLimitedReleaseDetailData: action.data,
      });
    case deleteSaLimitedReleaseDetailConstants.DELETE_SA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        deleteSaLimitedReleaseDetailLoading: false,
        deleteSaLimitedReleaseDetailData: null,
        deleteSaLimitedReleaseDetailError: action.error,
      });
    default:
      return state;
  }
}
